import ComponentsFactory from '../ComponentsFactory/ComponentsFactory'
import { OttTaboolaMidPageWidget } from '../../AdsComponents'
import { ICategoryTreeItem } from '../../../types'
import React, { useEffect, useRef } from 'react'

export const RailsView = ({ data }: { data: ICategoryTreeItem[] }) => {
  const taboolaCounter = useRef(0)

  const [client, setClient] = React.useState(false)

  useEffect(() => {
    setClient(true)
  }, [])

  return (
    <React.Fragment>
      {data.map((rail, index) => {
        if (index > 4 && !client) {
          return null
        }
        return (
          <React.Fragment key={rail.id}>
            <ComponentsFactory data={rail} index={index} />
            {(() => {
              if (
                (index === 2 && data.length > index + 1) ||
                (index > 3 && (index - 2) % 5 === 0 && data.length > index + 1)
              ) {
                return (
                  <OttTaboolaMidPageWidget counter={++taboolaCounter.current} />
                )
              }
              return null
            })()}
          </React.Fragment>
        )
      }) || []}
    </React.Fragment>
  )
}
